"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ReferenceArrayFieldController_1 = __importDefault(require("./ReferenceArrayFieldController"));
exports.ReferenceArrayFieldController = ReferenceArrayFieldController_1.default;
var ReferenceFieldController_1 = __importDefault(require("./ReferenceFieldController"));
exports.ReferenceFieldController = ReferenceFieldController_1.default;
var ReferenceManyFieldController_1 = __importDefault(require("./ReferenceManyFieldController"));
exports.ReferenceManyFieldController = ReferenceManyFieldController_1.default;